// extracted by mini-css-extract-plugin
export default {"currencies":"ProviderCurrenciesCell_currencies__UoS+j","currency":"ProviderCurrenciesCell_currency__RLI2+","more":"ProviderCurrenciesCell_more__gtRgl"};